const creativesLibraryAPIPrefix = (accountId, creativeId) => `/${accountId}/creatives/${creativeId}`;
const creativesLibraryCreateAPIPrefix = (accountId, isDuplicated) =>
    `/${accountId}/creatives/bulk/create?is_duplicated=${isDuplicated}`;

export const creativesLibraryApiFactory = ({ callGetApi, callPutApi, callPostApi, callDeleteApi }) => ({
    updateLibraryCreative: (accountId, creativeId, changes) =>
        callPutApi(creativesLibraryAPIPrefix(accountId, creativeId), changes),
    createBulkLibraryCreatives: ({ accountId, isDuplicated = false, body }) => {
        return callPostApi(creativesLibraryCreateAPIPrefix(accountId, isDuplicated), body);
    },
    getLibraryCreative: (accountId, creativeId) => callGetApi(creativesLibraryAPIPrefix(accountId, creativeId)),
    deleteLibraryCreative: (accountName, creativeId) =>
        callDeleteApi(creativesLibraryAPIPrefix(accountName, creativeId)),
});
